import { useGetList } from 'react-admin';

import type { B2bContractStatus } from '@Common/types/bo/b2b/contracts';

import { contractIdsOpenForVoluntaryPayment } from '@sh4res/bo-common/components/B2bVoluntaryPayment/contractIdsOpenForVoluntaryPayment';
import { useResourceBasePath } from '@sh4res/bo-common/hooks';

export function useOpenVoluntaryPaymentContractIds(contractIds: unknown): {
  openContractIds: number[];
  allAffiliationsTerminated: boolean;
} {
  const resourceBasePath = useResourceBasePath();
  const affiliationIds = Array.isArray(contractIds)
    ? contractIds.filter((contractId): contractId is number => typeof contractId === 'number')
    : [];

  const { data, isLoading, error } = useGetList<{ id: number; status?: B2bContractStatus }>(
    `${resourceBasePath}contracts`,
    {
      filter: { id: affiliationIds },
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'id', order: 'ASC' },
    },
    { enabled: affiliationIds.length > 0 },
  );

  // Stay empty until the affiliation statuses are known, so terminated plans never flash in the dropdown.
  const waitingForContracts =
    affiliationIds.length > 0 && (isLoading || data === undefined) && !error;
  const openContractIds =
    waitingForContracts || error
      ? []
      : contractIdsOpenForVoluntaryPayment(affiliationIds, data ?? []);

  return {
    openContractIds,
    allAffiliationsTerminated:
      affiliationIds.length > 0 && !waitingForContracts && !error && openContractIds.length === 0,
  };
}
